export default {"src":"/_next/static/media/menu-bg-blue.602820d8.svg","height":812,"width":375,"blurWidth":0,"blurHeight":0};